import React, { useState, useEffect } from "react";
import { Button, Input } from "../../common";
const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const [jumpPage, setJumpPage] = useState(currentPage);
  useEffect(() => {
    setJumpPage(currentPage);
  }, [currentPage]);
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return null;
  const goPrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };
  const goNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  const handleJump = (e) => {
    e.preventDefault();
    const page = Number(jumpPage);
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };
  return (
    <div className="np-pagination">
      <Button
        variant="outline"
        disabled={currentPage === 1}
        onClick={goPrev}
      >
        <i className="fe fe-chevron-left fs-5"></i>
      </Button>
      <form onSubmit={handleJump}>
        <Input
          type="number"
          min="1"
          max={totalPages}
          value={jumpPage}
          onChange={(e) => setJumpPage(e.target.value)}
          className="np-pagination__input"
        />
      </form>
      <Button variant="outline">of {totalPages} pages</Button>
      <Button
        variant="outline"
        disabled={currentPage === totalPages}
        onClick={goNext}
      >
        <i className="fe fe-chevron-right fs-5"></i>
      </Button>
    </div>
  );
};
export default Pagination;
